var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 25 25"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "edit_svg__a",
    width: 25,
    height: 25,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.616.651h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#edit_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.616 19.65h1.425l9.776-9.774-1.425-1.425-9.776 9.775zm-2 2V17.4l13.2-13.174q.3-.276.663-.425.363-.15.762-.15.4 0 .776.15.375.15.65.45l1.374 1.4q.3.275.438.65a2.17 2.17 0 0 1 0 1.512 1.9 1.9 0 0 1-.437.663L7.865 21.65zM16.092 9.177l-.7-.725 1.425 1.425z"
  }))));
};
export default SvgEdit;